import { CategoryTree } from "src/molecules/CategoryTree";
import {
  CategoryTreeWrapper,
  GridWrapper,
  ListingContainer,
} from "./ProductList.styled";
import { AdditionalCategories } from "../AdditionalCategories";
import { CategoryTreeProvider } from "src/contexts/category-tree-context";
import {
  InstantSearch,
  InstantSearchServerState,
  InstantSearchSSRProvider,
} from "react-instantsearch-core-v7";
import { SearchClient } from "algoliasearch";
import { Promotion } from "./Promotion";
import { Grid } from "./Grid";
import { PLPType } from "src/types/PLPType.d";
import { NavigationItems } from "src/types/graphql.d";

export type ProductListProps = {
  slug: string;
  gender: string;
  pageContentType: PLPType;
  categoryPageId: string;
  indexName: string;
  searchClient: SearchClient;
  serverState?: InstantSearchServerState;
  excludeFilters?: string[];
  title?: string;
  navigationItems?: NavigationItems;
};

function ProductList({
  indexName,
  searchClient,
  gender,
  slug,
  categoryPageId,
  pageContentType,
  serverState,
  excludeFilters,
  title,
  navigationItems,
}: ProductListProps): JSX.Element {
  return (
    <InstantSearchSSRProvider {...serverState}>
      <CategoryTreeProvider>
        <ListingContainer>
          <CategoryTreeWrapper>
            <AdditionalCategories navigationItems={navigationItems} />

            <CategoryTree
              gender={gender}
              categoryPageId={categoryPageId}
              pageContentType={pageContentType}
              brandName={title}
            />
          </CategoryTreeWrapper>

          <GridWrapper>
            {pageContentType !== PLPType.BRAND_PLP ? (
              <Promotion gender={gender} slug={slug} />
            ) : null}

            <InstantSearch
              searchClient={searchClient}
              future={{ preserveSharedStateOnUnmount: true }}
              indexName={indexName}
            >
              <Grid
                title={title}
                indexName={indexName}
                gender={gender}
                pageContentType={pageContentType}
                slug={slug}
                categoryPageId={categoryPageId}
                excludeFilters={excludeFilters}
              />
            </InstantSearch>
          </GridWrapper>
        </ListingContainer>
      </CategoryTreeProvider>
    </InstantSearchSSRProvider>
  );
}

export { ProductList };
